import { FC } from "react"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"
import { PageHeader } from "../../common/ui"
import { RequireRole } from "../../common/validation"
import { useFetchOrgListQuery } from "../../redux/queries"
import ChannelLeads from "../../common/ui/channel-leads"

const ChannelLeadsPage: FC = () => {
  const { data: orgs = [] } = useFetchOrgListQuery({ limit: 999 })

  // Filter out disabled orgs
  const activeOrgs = orgs.filter(org => !org.disabled)

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["channel-leads"]}>
      <div className="min-h-full bg-gray-50">
        <div className="p-6 space-y-6">
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
            <PageHeader
              title="Channel Leads"
              hasSubtitle
              subtitle="Manage affiliate channel partners and lead billing"
            />
          </div>

          <ChannelLeads orgs={activeOrgs} />
        </div>
      </div>
    </RequireRole>
  )
}

export default ChannelLeadsPage
